
import {HttpHeaders} from '@angular/common/http';
import {AppSetting} from '../AppSetting';
import {AppSettingApi} from '../AppSettingApi';
import {BaseService} from '../Service/BaseService';
import {BaseWebApiDAO} from './BaseWebApiDAO';

/**
 * UserDAO
 * ユーザー取得系API
 */
export class FileDAO extends BaseWebApiDAO {

  // コンストラクタ
  constructor(svc: BaseService) {
    super(svc);
  }


  public async downloadFileUri(id: number) {

    const request = {
      t: this.token,
      id
    };

    const ret = await this.postRequest(AppSettingApi.FILE_DOWNLOAD, request);
    return ret;

  }

}
